<template>
  <div data-testid="nav-flag" :title="titleBuilder(regionCode)" class="nav-flag" :style="{ width, height }">
    <Picture
      :image-url="flagIconUrl"
      :alt="flagIconAlt"
      :using-scene7="false"
      :pt="{
        img: {
          loading: 'eager',
        },
      }"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Picture from '@nuxt-common/atomic-ui/app/components/picture/Picture';
import { getFlagUrl } from 'config';
import getAssetImage from '~/utils/getAssetImage';

defineProps({
  width: {
    type: String,
    default: '21px',
  },
  height: {
    type: String,
    default: '14px',
  },
  titleBuilder: {
    type: Function,
    default: (regionCode) => regionCode,
  },
});

const pageData = usePageData();

const regionCode = computed(() => pageData.navigation.context.regionCode);
const flagIconUrl = computed(() => getFlagUrl(regionCode.value, getAssetImage));
const flagIconAlt = computed(() => `${regionCode.value} current selected country`);
</script>

<style scoped lang="scss">
.nav-flag {
  width: 100%;
  height: 100%;
}

.rounded {
  :deep(img) {
    border-radius: 50%;
  }
}

:deep(.picture-container) {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

:deep(img) {
  vertical-align: top;
  height: 100%;
}
</style>
